module.exports = __webpack_public_path__ + "img/meat-poultry.0b5ef790.svg";